/**
 * @description 금액 포맷팅
 * @param currentPrice
 * @returns 포맷팅된 금액 문자열
 * - 소수점 이하 2자리까지 표시
 * - 천 단위마다 콤마 추가
 * - 앞에 ₩ 기호 추가
 * - 예시: "₩ 1,000,000"
 */
export const formatPrice = (currentPrice) => {
    return `₩ ${Number(currentPrice).toLocaleString()}`;
};
/**
 * @description 최고 ~ 최저 금액 포맷팅
 * @param min 최저 금액
 * @param max 최고 금액
 * @returns 포맷팅된 금액 문자열
 * - 두 값이 모두 null인 경우 => "0"
 * - 두 값이 같거나 하나만 존재하는 경우 => 둘 중 하나의 값으로 표시 => "₩ 1,000"
 * - 두 값이 다른 경우 범위로 표시 => "₩ 1,000 ~ ₩ 2,000"
 */
export const formatPriceRange = (min, max) => {
    if (min === null && max === null) {
        return "0";
    }
    if (min === max || !min || !max) {
        return formatPrice(min || max);
    }
    return `${formatPrice(min)} ~ ${formatPrice(max)}`;
};
export const formatPriceAuto = (params) => {
    if (params.current === params.min && params.current === params.max) {
        return formatPrice(params.current);
    }
    return formatPriceRange(params.min, params.max);
};
